/**
 * MonitoringDot - Pulsing indicator for active monitoring
 *
 * Renders a small pulsing circle when a collection is actively monitoring: teal while
 * the monitor is healthy, and in the health tone when it is not. Not rendered when
 * paused (no DOM element, not just hidden), whatever the health.
 *
 * Atomic level: Atom
 */

import React from 'react';
import type { MonitoringStatus, UnhealthyStatus } from '../../../../services/types/collection';

interface MonitoringDotProps {
  status: MonitoringStatus;
  tone?: UnhealthyStatus;
  title?: string;
  className?: string;
}

const TONE_COLOUR: Record<UnhealthyStatus, string> = {
  warning: 'bg-amber-500',
  critical: 'bg-[var(--go-berry)]',
};

const MonitoringDot: React.FC<MonitoringDotProps> = ({ status, tone, title, className = '' }) => {
  if (status !== 'active') return null;

  const colour = tone ? TONE_COLOUR[tone] : 'bg-[#07A0C3]';
  return (
    <span
      className={`inline-block w-1.5 h-1.5 rounded-full ${colour} animate-monitoring-pulse ${className}`}
      title={title ?? 'Monitoring — connected and running'}
    />
  );
};

export { MonitoringDot };
export type { MonitoringDotProps };
